/* eslint-disable require-jsdoc */
import { ENDPOINTS } from 'config/api';
import fetch from 'app/utilities/fetch';
import Template from 'app/components/templates/index';
import templateType from '../../utilities/template-type';
import { useParams } from 'react-router-dom';
import React, { createContext, useEffect, useState } from 'react';
import { POST_MESSAGE_TYPE } from '../../utilities/post-message-type';

// Context for nested components to determine whether the page is being rendered for live preview or not
// So that they can render additional UI for live page builder control
export const LivePreviewContext = createContext(false);

// Render the entity
function renderPage(page) {
    const {
        slug,
    } = page.attributes;

    const templateTypeToUse = templateType(slug, page.type);

    return (
        <main className="page" role="main">
            <Template
                type={templateTypeToUse}
                data={page.attributes}
            />
        </main>
    );
}

const LivePreview = () => {
    const { id } = useParams();

    const [page, setPage] = useState(null);

    // Fetch the entity from API live preview endpoint
    async function loadPreviewData() {
        try {
            const res = await fetch(ENDPOINTS.LIVE_PREVIEW(id));
            setPage(res.data);
        } catch (err) {
            //
        }
    }

    // Handle messages from parent document
    function handleUpdate(event) {
        // CMS will send us update message when it wants us to refresh
        if (event.data.type === POST_MESSAGE_TYPE.RELOAD_PAGE_DATA) {
            loadPreviewData();
        }
    }

    useEffect(async() => {
        // Load preview data
        loadPreviewData();

        // Listen for updates from CMS
        window.addEventListener('message', handleUpdate);

        return () => {
            window.removeEventListener('message', handleUpdate);
        };
    }, []);

    if (page) {
        return (
            <LivePreviewContext.Provider value={true}>
                {renderPage(page)}
            </LivePreviewContext.Provider>
        );
    }

    // TODO: return loader
    return null;
};

export default LivePreview;
